const menu = {
  topMenu: [
    {
      id: 'pacto', title: 'Pacto', url: '/pacto/dashboard',
      img: "/static/app-assets/images/icon/pacto.png"
    },
    {
      id: 'enterprise', title: 'Enterprise and Organization Management',
      url: '/enterprise/clo/organisation', img: "/static/app-assets/images/icon/enterprize.svg"
    }
  ],
  enterprise: {
    menuItems: [
      {
        title: 'sidebar_module_menu_item_title',
        subMenu: [
          {
            name: 'sidebar_module_menu_item_title',
            iconClass: 'desktop',
            component: 'EnterpriseProfilePage'
          }
        ]
      },
      {
        title: 'sidebar_module_menu_item_title_organization',
        subMenu: [
          {
            name: 'sidebar_module_menu_item__organization_profile',
            iconClass: 'desktop',
            component: 'CLOListPage',
          }
        ]
      },
      {
        title: 'sidebar_module_menu_item__organization_support',
        subMenu: [
          {
            name: 'sidebar_module_menu_item__organization_support_request',
            iconClass: 'desktop',
            component: 'SupportRequestsPage'
          },
          {
            name: 'sidebar_module_menu_item__organization_support_request_chats',
            iconClass: 'comments',
            component: 'CLOChatsPage'
          }
        ]
      },
    ]
  },
  pacto: {
    menuItems: [


      {
        title: 'sidebar_module_pact_menu_item_heading_pacto_user_management',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_management_invites',
            iconClass: 'envelope-put',
            component: 'InvitesPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_management_tenant',
            iconClass: 'users',
            component: 'TenantsPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_management_properties_owners',
            iconClass: 'home',
            component: 'LandlordsPage',
            path: '/landlords'
          }
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_heading_pacto_properties',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_properties',
            iconClass: 'briefcase',
            component: 'HousesPage'
          }
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_heading_pacto_contracts',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_proposals',
            iconClass: 'pencil',
            component: 'ContractProposalsPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_contracts',
            iconClass: 'pen',
            component: 'ContractsPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_move_in_or_move_out',
            iconClass: 'swap-horizontal',
            component: 'MoveInMoveOutPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_payments',
            iconClass: 'coins',
            component: 'PaymentsPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_issues',
            iconClass: 'warning-alt',
            component: 'IssuesPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_conversations',
            iconClass: 'comments',
            component: 'ConversationPage'
          },
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_pacto_support_and_feedback',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_support_request',
            iconClass: 'servers',
            component: 'CLOSupportRequest'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_application_support',
            iconClass: 'smartphone',
            component: 'ApplicationsForSupportPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_feedback',
            iconClass: 'pencil',
            component: 'UserFeedbackPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_gdpr_request',
            iconClass: 'radiation',
            component: 'GDPRRequestsPage'
          }
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_pacto_heading_content_management',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_contract_templates',
            iconClass: 'responsive',
            component: 'ContractTemplatesPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_terms_and_condition',
            iconClass: 'envelope-put',
            component: 'PrivacyPolicyView'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_hints_and_tips',
            iconClass: 'bulb',
            component: 'HintsAndTipsPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_support_section_content',
            iconClass: 'like',
            component: 'SupportSectionContent'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_faq',
            iconClass: 'question-alt',
            component: 'FAQPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_user_word_and_phase_blacklisting',
            iconClass: 'priority-high',
            component: 'WordAndPhaseBlacklistingPage'
          }
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_pacto_heading_reports',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_heading_reports',
            iconClass: 'notebook',
            component: 'CLOReportsPage'
          }
        ]
      },
      {
        title: 'sidebar_module_pact_menu_item_pacto_heading_pacto_deployment_settings',
        subMenu: [
          {
            name: 'sidebar_module_pact_menu_item_pacto_regions_and_countries',
            iconClass: 'globe',
            component: 'RegionsAndCountriesPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_languages',
            iconClass: 'euro',
            component: 'LanguagesPage'
          },
          {
            name: 'sidebar_module_pact_menu_item_pacto_currencies',
            iconClass: 'us-dollar',
            component: 'CurrenciesPage'
          }
        ]
      },
    ]
  }


}

export default menu;
